<div class="container-fluid ter-container">
    <fap-units-layout
        [units]="globalRegistry.systemData.units"
        [farms]="globalRegistry.systemData.farms">
    </fap-units-layout>
</div>
